import React, { useMemo, useRef, useState, useEffect } from "react";
import debounce from "lodash/debounce";
import ToastAlert from "../../../components/CommonSection/ToastAlert/ToastAlert";
import { useNavigate } from "react-router-dom";
import { getemailmessageslist, SearchContacts, sendemailinspection, FilePath, sendemailfromoutbox, deleteemailfromoutbox, getemaildetailsbyid, updateemailmessage, createemailmessage } from "../../../components/CommonSection/apiresources";
import { GetCookie, currentProfile } from "../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner, uploadToS3WithSpinner } from "../../../Utilities/client";
import { useSpinnerContext } from "../../../Utilities/SpinnerContext";
import { ActionStatus } from "../../../Utilities/enum";
import { dynamicUrl } from "../../../Utilities/profileManagement";
import { Select, Spin, Dropdown, Button } from "antd";
import CustomModal from "../../input-components/Modal";
import TextBox from "../../input-components/textbox";
import moment from 'moment';
import SubNav from "../../../components/CommonSection/Header/subHeader";
import AntdTableExample from "../../input-components/dataTable";
import ReactQuill from "react-quill";
import { FileAddOutlined, MailOutlined, PrinterOutlined, FilePdfOutlined, TabletOutlined, DeleteOutlined, PaperClipOutlined } from '@ant-design/icons';
import '../Accounts/transaction/transaction.css'
import './outbox.css'
import DocumentUpload from "../../input-components/documentUpload";

const ListUndelivered = () => {
    const [undeliveredLists,  setUndeliveredLists] = useState([]);
    const [outboxDetails, setOutboxDetails] = useState([]);
    const [userId, setUserId] = useState("");
    const [agencyID, setAgencyId] = useState("");
    const [chartData, setChartData] = useState();
    const navigate = useNavigate();
    const ToastRef = useRef();
    const [searchText, setSearchText] = useState("");
    const [purpose, setPurpose] = useState("");
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [rows, setRows] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [fetching, setFetching] = useState(false);
    const [searchValue, setSearchValues] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [tenantFolioId, setTenantFolioId] = useState(null);
    const currentUser = currentProfile.get();
    const [openAddMsg, setOpenAddMsg] = useState(false)
    const [optionContact, setOptionContact] = useState([]);
    const [agentId, setAgentId] = useState("");
    const [emailLabel, setEmailLabel] = useState("");
    const [editMail, setEditMail] = useState(false)
    const [subject, setSubject] = useState("");
    const [email, setEmail] = useState([]);
    const [emailContent, setEmailContent] = useState("");
    const [selectedValues, setSelectedValues] = useState([]);
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [openViewEmail, setOpenViewEmail] = useState(false);
    const [selectedRow, setSelectedRow] = useState([]);

    const fetchRef = useRef(0);
    const inputRef = useRef();
    const [propertyImages, setPropertyImages] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setUserId(parsedData.userId);
                    setAgencyId(parsedData.agencyID);
                    PostApiWithSpinner(parsedData.agencyID,1,10)
                    setTenantFolioId(parsedData.tenantFolioId)
                    setAgentId(parsedData.agentId);

                }
            } catch (error) {
                console.error("Error retrieving data from AsyncStorage:", error);
            }
        };
        retrieveData();
    }, [userId, searchText, searchValue]);



    const PostApiWithSpinner = (agencyID,currentPage, totalRows) => {
        const baseUrl = getemailmessageslist;
        let data = {
            AgencyId: agencyID,
            Status: 3,
            RecordsPerPage: totalRows,
            SortBy: "CreatedDate",
            SortOrder: "Desc",
            Search: searchText,
            PageNo: currentPage,
        };
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    const outboxData = response.object.emailList || [];
                    let outboxList = outboxData.map((outbox) => ({
                        Recipient: `${outbox.recipientName} ${outbox.recipientEmail}`,
                        "Subject/Template": outbox.subject,
                        Member: "",
                        Date: outbox.createdDate  ? moment(outbox.createdDate).format('DD-MM-YYYY') : "",
                        Created: outbox.createdDate ? moment(outbox.createdDate).format('hh:mm A') : "",
                        guid: outbox.id

                    }));
                     setUndeliveredLists(outboxList);
                    setOutboxDetails(response.object);
                    setTotalPages(response.totalCount);
                }
            })
    };

    const handlePageChange = (pageNumber, totalRows) => {
        setUndeliveredLists([]);
        setCurrentPage(pageNumber);
        setRows(totalRows);
        PostApiWithSpinner(agencyID, pageNumber, totalRows);
    };

    const handleAddMsg = (e) => {
        setEmailLabel(e.target.textContent);
        setOpenAddMsg(true);

        // Reset all form state
        setEmail([]);
        setEmailContent("");
        setSubject("");
        setSelectedValues([]);
        setPropertyImages([]);
        setSelectedEmail(null);
        setOpenViewEmail(false);
    };


    const handleCancleMsg = (e) => {
        setOpenAddMsg(false)
    }

    useEffect(() => {
        agentUIDRef.current = agentId;
    }, [agentId]);

    const agentUIDRef = useRef(agentId);

    const debounceFetcherContact = useMemo(() => {
        const loadOptions = (value) => {
            setOptionContact([]);
            setFetching(true);
            let data = {
                Search: value,
                RecordsPerPage: 10,
                PageNo: 1,
                AgentID: agentUIDRef.current,
            };

            makeRequestWithSpinner(
                showSpinner,
                hideSpinner,
                SearchContacts,
                "post",
                data
            )
                .then((response) => {
                    const transformedData = response.list.map((item) => ({
                        value: item.id,
                        label: item.name,
                        uid: item.uid,
                        email: item.email
                    }));
                    setOptionContact(transformedData);
                    setFetching(false);
                })
                .catch((error) => setFetching(false));
        };

        return debounce(loadOptions, 800); // Debounce time of 800ms
    }, []);

    const handleSearchChange = (newSelectedOptions) => {
        console.log(newSelectedOptions, 'newSelectedOptions');

        if (!Array.isArray(newSelectedOptions)) return;

        // Map to full object by looking up from optionContact
        const enrichedOptions = newSelectedOptions.map((opt) => {
            return optionContact.find(o => o.value === opt.value) || opt;
        });

        const validNewOptions = enrichedOptions.filter((opt) => opt && opt.email);
        console.log(validNewOptions, 'validNewOptions');

        const combined = [...selectedValues, ...validNewOptions];
        const deduplicated = Array.from(
            new Map(combined.map((item) => [item.email, item])).values()
        );

        setSelectedValues(deduplicated);
        setEmail(deduplicated.map((v) => v.email));
    };


    const handleSendMail = () => {
        let finalData = {
            Emails: email,
            BodyEmail: emailContent,
            Subject: subject,
        }
        if (email === "") {
            ToastRef.current.notify(["error", "Email is required"]);
        } else {
            const url = sendemailinspection;
            makeRequestWithSpinner(showSpinner, hideSpinner, url, "post", finalData)
                .then((returnData) => {
                    if (returnData.status === ActionStatus.Successfull) {
                        ToastRef.current.notify(["success", returnData.message]);
                        setOpenAddMsg(false);
                    } else {
                        ToastRef.current.notify(["error", returnData.message]);
                    }
                })
                .catch((error) => {
                    ToastRef.current.notify(["error", error.message]);
                });
        }
    };

  const handleCreateNewMail = async () => {
  if (email.length === 0) {
    ToastRef.current.notify(["error", "At least one recipient is required"]);
    return;
  }

  const attachments = await Promise.all(
    propertyImages.map(async (file) => {
      const fileContent = await fetch(file.src)
        .then(res => res.blob())
        .then(blob => new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result.split(',')[1]); // base64
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        }));

      return {
        id: file.id || 0,
        fileName: file.fileName,
        contentType: file.fileName.endsWith(".pdf") ? "application/pdf" : "image/png",
        fileContent,
      };
    })
  );

  const joinedEmails = email.join(",");
const joinedNames = selectedValues
  .map(v => v.label.replace(/\s*\(.*?\)\s*/g, "").trim()) // Removes anything in ()
  .join(",");
  const finalData = {
    recipientEmail: joinedEmails,      // ✅ "email1,email2"
    recipientName: joinedNames,         // ✅ "name1,name2"
    subject: subject,
    body: emailContent,
    attachments: attachments,
    agencyId: agencyID,
  };

  makeRequestWithSpinner(showSpinner, hideSpinner, createemailmessage, "post", finalData)
    .then((returnData) => {
      if (returnData.status === ActionStatus.Successfull) {
        ToastRef.current.notify(["success", returnData.message]);
        setOpenAddMsg(false);
          PostApiWithSpinner(agencyID,1,10);
      } else {
        ToastRef.current.notify(["error", returnData.message]);
      }
    })
    .catch((error) => {
      ToastRef.current.notify(["error", error.message]);
    });
};



    const handleUpdateExistingMail = async () => {
        if (!selectedEmail || email.length === 0) {
            ToastRef.current.notify(["error", "Email is required"]);
            return;
        }

        const attachments = await Promise.all(
            propertyImages.map(async (file) => {
                const fileContent = await fetch(file.src)
                    .then(res => res.blob())
                    .then(blob => new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onloadend = () => resolve(reader.result.split(',')[1]); // base64
                        reader.onerror = reject;
                        reader.readAsDataURL(blob);
                    }));

                return {
                    id: file.id || 0,
                    fileName: file.fileName,
                    contentType: file.fileName.endsWith(".pdf") ? "application/pdf" : "image/png",
                    fileContent,
                };
            })
        );

        const joinedEmails = email.join(",");
        const joinedNames = selectedValues
  .map(v => v.label.replace(/\s*\(.*?\)\s*/g, "").trim()) // Removes anything in ()
  .join(",");

        const finalData = {
            id: selectedEmail.id,
            recipientName: joinedNames,         // ✅ Only names (labels)
            recipientEmail: joinedEmails,       // ✅ Only emails
            subject: subject,
            body: emailContent,
            attachments: attachments,
        };

        makeRequestWithSpinner(showSpinner, hideSpinner, updateemailmessage, "post", finalData)
            .then((res) => {
                if (res.status === ActionStatus.Successfull) {
                    ToastRef.current.notify(["success", res.message]);
                    setOpenAddMsg(false);
                } else {
                    ToastRef.current.notify(["error", res.message]);
                }
            })
            .catch((err) => {
                ToastRef.current.notify(["error", err.message]);
            });
    };



    const handleActionClick = ({ key }) => {
        if (key === '1') {
            setOpenViewEmail(false);
            setEmailLabel("Edit Email");
            setOpenAddMsg(true);
            setEditMail(true)

            const newRecipient = {
                label: `${selectedEmail.recipientName} (${selectedEmail.recipientEmail})`,
                value: selectedEmail.recipientEmail,
                email: selectedEmail.recipientEmail,
            };

            // Merge with existing (e.g., previously selected values before edit)
            const combined = [...selectedValues, newRecipient];

            // Deduplicate by email
            const deduplicated = Array.from(
                new Map(combined.map((item) => [item.email, item])).values()
            );

            setSelectedValues(deduplicated);
            setEmail(deduplicated.map((v) => v.email));

            setSubject(selectedEmail.subject);
            setEmailContent(selectedEmail.body);

            if (selectedEmail.attachments) {
                const existingAttachments = selectedEmail.attachments.map(file => ({
                    id: file.id,
                    fileName: file.fileName,
                    src: `${FilePath}${file.fileName}`
                }));
                setPropertyImages(existingAttachments);
            }
        }
    };


    const items = [
        { key: '1', label: (<a onClick={handleAddMsg}>Email</a>) },
        { key: '2', label: (<a>SMS</a>) },
        { key: '3', label: (<a>Manage Template</a>) },
    ];

    const actionItems = [
        { key: '1', label: (<a>Edit</a>) },
        { key: '2', label: (<a>Delete</a>) },
        { key: '3', label: (<a>Report</a>) },
    ];



    const handleStatClick = (selectedPurpose) => {
        setPurpose(selectedPurpose);
    };

    const handleUploadImage = async (e) => {
        const files = Array.from(e.target.files);
        for (let file of files) {
            setSelectedFile(file); // optional, for tracking last
            await handleUpload(file);
        }
    };

    const handleUpload = async (file) => {
        const folder = "property/";
        const key = `property_${Date.now()}`;

        await uploadToS3WithSpinner(showSpinner, hideSpinner, folder, key, file).then((returnData) => {
            if (returnData.status === ActionStatus.Successfull) {
                const fileName = returnData.Key.split("/").pop();
                const transformedItem = {
                    id: Math.floor(Math.random() * 1000000),
                    src: FilePath + returnData.Key,
                    fileName: fileName,
                };
                setPropertyImages((prev) => [...prev, transformedItem]);
            }
        });
    };

    const onSelectedRowKeysChange = (id) => {
        setSelectedRow(id)
    }

    const handleSend = (id) => {
        const baseUrl = sendemailfromoutbox;
        let data = {
            AgencyId: agencyID,
            Ids: selectedRow.length > 0 ? selectedRow : [id],
        };
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    ToastRef.current.notify(["success", response.message]);
                    PostApiWithSpinner(agencyID,1,10);
                    if (id) {
                        setOpenViewEmail(false)
                    }
                }
            })
    };

    const handleDelete = () => {
        const baseUrl = deleteemailfromoutbox;
        let data = {
            AgencyId: agencyID,
            Ids: selectedRow,
        };
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "delete", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    ToastRef.current.notify(["success", response.message]);
                    PostApiWithSpinner(agencyID,1,10);
                }
            })
    };

    const getOutboxDetails = (event, rowData) => {
        const baseUrl = getemaildetailsbyid;
        let data = {
            AgencyId: agencyID,
            Id: rowData.guid,
        };
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    setOpenViewEmail(true);

                    setSelectedEmail(response.object);
                }
            })
    };

    const handleSearchValueChange = (value) => {
        setSearchText(value);
    };


    return (
        <div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                    <SubNav title={"Undelivered"} actionButton={false} extraData={true} goback={false} extraContent={<div></div>} />
                    <div className="material-work-desk-new bg-white m-3">
                        <ToastAlert ref={ToastRef} />
                        <div className="d-flex justify-content-between">
                            <div className="ml-3">
                                {/* <Button className="mr-2 withdraw-btn" type="default" icon={<MailOutlined />} onClick={handleSend}>
                                    Send
                                </Button> */}
                                {/* <Button className="mr-2 withdraw-btn" type="default" icon={<DeleteOutlined />} onClick={handleDelete}>
                                    Delete
                                </Button> */}
                                {/* <Dropdown menu={{ items }} placement="bottomLeft">
                                    <Button className="withdraw-btn" icon={<FileAddOutlined />} >New</Button>
                                </Dropdown> */}
                            </div>
                            <div className="bank-transaction-summary">
                                <div style={{ width: '200px' }} className="bank-summary-box mr-1">
                                    <div className="bank-details">
                                        <div style={{ fontSize: '14px' }} className="bank-count">{"Emails to send"}</div>
                                        <div className="bank-label">{outboxDetails.emailToSendCount}</div>
                                    </div>
                                    <div className="bank-arrow">
                                        <MailOutlined />
                                    </div>
                                </div>
                                {/* <div style={{ width: '200px' }} className="bank-summary-box">
                                    <div className="bank-details">
                                        <div style={{ fontSize: '14px' }} className="bank-count">{"To Print"}</div>
                                        <div className="bank-label">11</div>
                                    </div>
                                    <div className="bank-arrow">
                                        <PrinterOutlined />
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="property-stats-bar">
                            {[
                                { key: "", label: "Email", icon: <MailOutlined /> },
                                { key: "SMS", label: "SMS", icon: <TabletOutlined /> },
                                {/* { key: "Letter", label: "Letter", icon: <FilePdfOutlined /> },
                                { key: "Documents", label: "Documents", icon: <FilePdfOutlined /> },
                                { key: "Statement", label: "Statement", icon: <FilePdfOutlined /> },
                                { key: "Draft", label: "Draft", icon: <MailOutlined /> }, */}
                            ].map((item) => (
                                <div
                                    key={item.key}
                                    className={`stat-tab ${purpose === item.key ? "active" : ""}`}
                                    onClick={() => handleStatClick(item.key)}
                                >
                                    {item.icon && <span className="stat-icon">{item.icon}</span>}
                                    <span>{item.label}</span>
                                    {"count" in item && (
                                        <span className="count-badge">{item.count}</span>
                                    )}
                                </div>
                            ))}
                        </div>

                        <AntdTableExample
                            showCheckbox
                            label="List Undelivered"
                            dataSource={undeliveredLists}
                            globalSearch
                            hideCol={"Member"}
                            onPageChange={handlePageChange}
                            currentPage={currentPage}
                            totalRows={rows}
                            totalRecords={totalPages}
                            onRowClick={getOutboxDetails}
                            onSelectedRowKeysChange={onSelectedRowKeysChange}
                            onSearchValueChange={handleSearchValueChange}
                        />

                        <CustomModal
                            title={emailLabel}
                            width={800}
                            closable={handleCancleMsg}
                            visible={openAddMsg}
                            onCancel={handleCancleMsg}
                            modalData={
                                <div className="row" style={{ marginTop: "20px", marginLeft: "10px" }}>
                                    <div className="pl-2 pr-2 row">
                                        <div className="col-lg-12 col-sm-12">
                                            <label className="s1">{"To"}</label>
                                            <Select
                                                mode="multiple"
                                                labelInValue
                                                placeholder="Search for contacts"
                                                showSearch
                                                filterOption={false}
                                                onSearch={debounceFetcherContact}
                                                notFoundContent={fetching ? <Spin size="small" /> : null}
                                                options={optionContact}
                                                onChange={handleSearchChange}
                                                value={selectedValues}
                                                allowClear
                                                style={{ width: "100%", minHeight: "auto" }}
                                                onDeselect={(value) => {
                                                    setSelectedValues((prev) => prev.filter((v) => v.value !== value.value));
                                                    setEmail((prev) => prev.filter((email) => email !== value.email));
                                                }}
                                            />

                                        </div>

                                        {/* Subject + Attachment */}
                                        <div className="col-lg-12 col-sm-12 mt-3">
                                            <label className="s1 d-block">Subject</label>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <input
                                                    type="text"
                                                    value={subject}
                                                    onChange={(e) => setSubject(e.target.value)}
                                                    placeholder="Enter subject"
                                                    className="form-control"
                                                    style={{ flex: 1 }}
                                                />
                                                <div
                                                    onClick={() => inputRef.current.click()}
                                                    style={{
                                                        backgroundColor: "#f0f0f0",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "4px",
                                                        padding: "6px 10px",
                                                        marginLeft: "10px",
                                                        cursor: "pointer",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                    title="Upload Attachment"
                                                >
                                                    <PaperClipOutlined style={{ fontSize: "18px" }} />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Hidden File Upload */}
                                        <input ref={inputRef} type="file" onChange={handleUploadImage} style={{ display: "none" }} multiple />

                                        {/* Email Body */}
                                        <div className="col-12 mt-3">
                                            <label htmlFor="lnumber" className="s1">
                                                Description<span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <ReactQuill
                                                className="w-100 d-flex flex-column"
                                                theme="snow"
                                                value={emailContent}
                                                onChange={(val) => setEmailContent(val)}
                                            />
                                        </div>
                                        {propertyImages.length > 0 && (
                                            <div className="col-12 mt-2">
                                                <label className="s1">Attachments</label>
                                                <div>
                                                    {propertyImages.map((file, index) => (
                                                        <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: 5 }}>
                                                            <a href={file.src} target="_blank" rel="noreferrer" style={{ marginRight: 10 }}>
                                                                <PaperClipOutlined size={20} /> {file.fileName}
                                                            </a>
                                                            <span
                                                                onClick={() => {
                                                                    const updated = [...propertyImages];
                                                                    updated.splice(index, 1);
                                                                    setPropertyImages(updated);
                                                                }}
                                                                style={{
                                                                    color: "red",
                                                                    cursor: "pointer",
                                                                    fontSize: 12,
                                                                }}
                                                            >
                                                                <DeleteOutlined />
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }

                            footer={[
                                <div className="mt-2" key="footer" style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <button className="pdb-cancel me-2" onClick={() => handleCancleMsg()}>
                                        Cancel
                                    </button>
                                    <button className="Add-Property-button" onClick={editMail ? handleUpdateExistingMail : handleCreateNewMail}>
                                        Submit
                                    </button>
                                </div>
                            ]}
                        />

                        <CustomModal
                            title={null}
                            width={1000}
                            closable={() => setOpenViewEmail(false)}
                            visible={openViewEmail}
                            onCancel={() => setOpenViewEmail(false)}
                            footer={null}
                            modalData={
                                selectedEmail && (
                                    <div className="email-preview-box">
                                        <div className="email-header">
                                            <div className="email-title">
                                                <MailOutlined />
                                                Email to {selectedEmail.recipientName}
                                            </div>
                                            {/* <div className="email-actions">
                                                <button className="email-btn send" onClick={() => handleSend(selectedEmail.id)}>📤 Send</button>
                                                <Dropdown menu={{ items: actionItems, onClick: handleActionClick }} placement="bottomLeft">
                                                    <Button className="withdraw-btn">Actions</Button>
                                                </Dropdown>
                                            </div> */}
                                        </div>

                                        <div className="email-meta">
                                            <div className="email-meta-row">
                                                <span className="email-meta-label">To:</span>
                                                <span className="email-meta-value" style={{ color: "#0d5c75" }}>
                                                    {selectedEmail.recipientName} ({selectedEmail.recipientEmail})
                                                </span>
                                            </div>
                                            <div className="email-meta-row">
                                                <span className="email-meta-label">Subject:</span>
                                                <span className="email-meta-value">{selectedEmail.subject}</span>
                                            </div>

                                        </div>

                                        <div
                                            className="email-body"
                                            dangerouslySetInnerHTML={{
                                                __html: `
                                                    <div style="font-family: Arial, sans-serif; padding: 0; margin: 0;background:white;">
                                                        <!-- Header -->
                                                        <div style="background-color: #0d5c75; padding: 10px; text-align: right;">
                                                        <img src="/assets/images/mainLogo.png" alt="RealtyMe" style="height: 80px;  filter: brightness(0) invert(1);" />
                                                        </div>

                                                        <!-- Content from API -->
                                                        <div style="padding: 20px;">
                                                        ${selectedEmail?.body || "No content available."}
                                                        </div>
                                                    </div>
                                                    `
                                            }}
                                        />
                                        {selectedEmail?.attachments?.length > 0 && (
                                            <div className="email-attachments mt-3" style={{ padding: "0 20px" }}>
                                                <h5 style={{ fontSize: "16px", fontWeight: "600", marginBottom: "10px" }}>Attachments</h5>
                                                <ul style={{ paddingLeft: 0 }}>
                                                    {selectedEmail.attachments.map((file, index) => (
                                                        <li key={index} style={{ listStyleType: "none", marginBottom: "6px" }}>
                                                            <a
                                                                href={`data:application/octet-stream;base64,${file.fileContent}`}
                                                                download={file.fileName}
                                                                style={{
                                                                    textDecoration: "none",
                                                                    color: "#0d5c75",
                                                                    fontSize: "14px",
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    gap: "8px"
                                                                }}
                                                            >
                                                                <PaperClipOutlined />
                                                                {file.fileName}
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}


                                    </div>
                                )
                            }
                        />



                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListUndelivered;
